module.exports = __webpack_public_path__ + "img/vto_tile.268de271.jpg";